import { css } from '@emotion/core';
import { aTag } from '@domain-group/fe-brary';
import { designTokenFonts } from '@domain-group/fe-co-allhomes-design-system';
export var cardLink = /*#__PURE__*/css(aTag, ";", designTokenFonts.caption, " display:flex;gap:5px;margin-top:19px;");
export var cardLinkIcon = {
  name: "18eau0h",
  styles: "height:18px;width:18px;"
};